import { render, staticRenderFns } from "./StatsPage.vue?vue&type=template&id=3f297931&scoped=true&"
import script from "./StatsPage.vue?vue&type=script&lang=js&"
export * from "./StatsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f297931",
  null
  
)

export default component.exports